/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Locked_By_IntegrationInputs */



/**
* | output |
* | --- |
* | "This event group was locked by the host application and cannot be unlocked here." |
*
* @param {Event_Group_Locked_By_IntegrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_locked_by_integration = /** @type {((inputs?: Event_Group_Locked_By_IntegrationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Locked_By_IntegrationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("This event group was locked by the host application and cannot be unlocked here.")
	if (locale === "de") return /** @type {LocalizedString} */ ("This event group was locked by the host application and cannot be unlocked here.")
	if (locale === "it") return /** @type {LocalizedString} */ ("This event group was locked by the host application and cannot be unlocked here.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("This event group was locked by the host application and cannot be unlocked here.")
	if (locale === "es") return /** @type {LocalizedString} */ ("This event group was locked by the host application and cannot be unlocked here.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("This event group was locked by the host application and cannot be unlocked here.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("This event group was locked by the host application and cannot be unlocked here.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("This event group was locked by the host application and cannot be unlocked here.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("This event group was locked by the host application and cannot be unlocked here.")
	return /** @type {LocalizedString} */ ("This event group was locked by the host application and cannot be unlocked here.")
});